import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_5 = {
  key: 1,
  class: "input-group-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.inputLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: `input-${_ctx.inputId}`,
          class: "form-label"
        }, [
          _createTextVNode(_toDisplayString(_ctx.inputLabel) + " ", 1),
          (_ctx.requiredFlag)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.frontGroup)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.frontGroup), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.backGroup)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.backGroup), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}